/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExamSexDto
 */
export interface ExamSexDto {
    /**
     * 
     * @type {string}
     * @memberof ExamSexDto
     */
    sex?: string | null;
}

/**
 * Check if a given object implements the ExamSexDto interface.
 */
export function instanceOfExamSexDto(value: object): value is ExamSexDto {
    return true;
}

export function ExamSexDtoFromJSON(json: any): ExamSexDto {
    return ExamSexDtoFromJSONTyped(json, false);
}

export function ExamSexDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamSexDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sex': json['sex'] == null ? undefined : json['sex'],
    };
}

export function ExamSexDtoToJSON(value?: ExamSexDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sex': value['sex'],
    };
}

